import useQueryBankAccountStatusesHook from '@fd/customHooks/useQueryBankAccountStatusesHook';

import { useAppSelector } from '../../../../custom-hooks/useAppSelector';
import { flagService } from '../../../../services/flagService';

/**
 * Shared payout failure lookup for bank accounts, used by both the list item warning icon and the
 * account details warning message. Returns a matcher for an account's StripeConnectedAccountInfo
 * StripeId, which the bank account status API returns as accountId.
 */
const useHasFailedPayout = () => {
  const isPayoutFailedBannerOn = useAppSelector((state) =>
    flagService.isFlagOn(state, 'payout_failed_banner')
  );
  const orgId = useAppSelector((state) => state.currentApp?.OrgId ?? '');
  const brandId = useAppSelector((state) => state.currentApp?.AppId ?? '');
  const isFlipdishGlobal = brandId === 'flipdish-global';
  const isEnabled = isPayoutFailedBannerOn && !isFlipdishGlobal;

  const { hasFailedPayoutForStripeId } = useQueryBankAccountStatusesHook(orgId, brandId, isEnabled);

  return (stripeId?: string) => isEnabled && hasFailedPayoutForStripeId(stripeId);
};

export default useHasFailedPayout;
